import React from "react";
import { Tooltip, Box, IconButton } from "@mui/material";
import { IconApprove, IconApproved } from "@components";
import { approveStatusStyle, approveDisabledStyle } from "./styles";

export const ApproveStatus = ({
  isApproved,
  canApprove,
  onApproveClick,
}: {
  isApproved: boolean;
  canApprove: boolean;
  onApproveClick: (event: React.SyntheticEvent) => void;
}) =>
  isApproved ? (
    <Tooltip title="Text is approved">
      <Box sx={{ pt: 1 }}>
        <IconApproved />
      </Box>
    </Tooltip>
  ) : (
    <Tooltip title="Approve">
      {canApprove ? (
        <IconButton onClick={onApproveClick} sx={approveStatusStyle}>
          <IconApprove />
        </IconButton>
      ) : (
        <Box sx={approveDisabledStyle}>
          <IconApprove />
        </Box>
      )}
    </Tooltip>
  );
